module.exports = __webpack_public_path__ + "eab3257dd5e841f4b0d3fbe2963e94d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/diamond/images/fluorescence_diamond_ring.png
// module id = 339
// module chunks = 0